import React, { useState, lazy, useEffect } from 'react';

const layout = window.$environment?.CURRENT_LAYOUT;
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const beBaseUrl = window?.$environment?.BE_BASE_URL;

// Utility function to render event lists
const renderEventList = (data, i18n) => {
  if (data?.length) {
    return data.map((ele, index) => (
      <ul key={index}>
        <li>
          <span className="name">{ele.status}</span>
          <span className="message">{ele.start}</span>
        </li>
      </ul>
    ));
  }
  return (
    <ul>
      <li style={{ textAlign: 'center' }}>
        <span className="name">{i18n.t('No data available')}</span>
      </li>
    </ul>
  );
};

// Component for the PDF iframe
const PdfFrame = ({ docLink }) => (
  <div className="pdfWrap">
    <iframe src={docLink} width="100%" height="720px"></iframe>
  </div>
);

// Component for the Regenerate PDF button
const RegeneratePdfButton = ({ regeneratePdf, list, currentIndex, date, getDocumentToken, tokenPdfShow, i18n }) => (
  <div id="regeneratePdf-wrapper">
    <Link
      id="regeneratePdf"
      onClick={() =>
        regeneratePdf({
          date: list[currentIndex - 1]?.day || date,
          callbackFuntion: () => {
            if (date && date.includes('-')) {
              getDocumentToken({ apiId: 'getDocToken', callback: tokenPdfShow });
            }
          },
        })
      }
    >
      {i18n.t('common.regeneratePdf')}
    </Link>
  </div>
);

// Component for the event list
const EventList = ({ eventsData, updateShowEvents, getLogbookEvents, selectedDailyLog, i18n }) => (
  <>
    <Button
      label={eventsData?.showEvents ? i18n.t('common.viewLess') : i18n.t('common.viewMore')}
      onClick={() => {
        if (eventsData?.showEvents) {
          updateShowEvents(false);
        } else {
          if (Boolean(eventsData?.data?.engineEvents)) {
            updateShowEvents(true);
          } else {
            getLogbookEvents(selectedDailyLog?.idPub || '');
          }
        }
      }}
    />
    {eventsData?.showEvents && (
      <div className="events">
        <div className="eventContainer">
          <div className="heading">{i18n.t('Engine Events')}</div>
          {renderEventList(eventsData?.data?.engineEvents, i18n)}
        </div>
        <div className="eventContainer">
          <div className="heading">{i18n.t('Login Events')}</div>
          {renderEventList(eventsData?.data?.loginEvents, i18n)}
        </div>
      </div>
    )}
  </>
);

// Main PdfView Component
const PdfView = ({
  list,
  i18n,
  date,
  driver,
  Styled,
  documentToken,
  fetchLogBookView,
  getLogbookEvents,
  updateShowEvents,
  getDocumentToken,
  selectedDailyLog,
  regeneratePdf,
  currentIndex,
  setCurrentIndex,
  eventsData,
}) => {
  const [docLink, setDocLink] = useState('');

  const getIndex = () => {
    const formattedDate = date?.replace('/', '-');
    return list.findIndex((element) => element.day === formattedDate) || 0;
  };

  const tokenPdfShow = (type, data) => {
    const index = getIndex();
    setCurrentIndex(index);
    setDocLink(
      `${beBaseUrl}/document/open/${selectedDailyLog?.document?.id}?token=${data}&output=embed`
    );
  };

  useEffect(() => {
    if (date && date.includes('-')) {
      getDocumentToken({ apiId: 'getDocToken', callback: tokenPdfShow });
    }
  }, [date, driver]);

  return (
    <Styled.PdfContainer>
      <PdfFrame docLink={docLink} />
      <RegeneratePdfButton
        regeneratePdf={regeneratePdf}
        list={list}
        currentIndex={currentIndex}
        date={date}
        getDocumentToken={getDocumentToken}
        tokenPdfShow={tokenPdfShow}
        i18n={i18n}
      />
      <EventList
        eventsData={eventsData}
        updateShowEvents={updateShowEvents}
        getLogbookEvents={getLogbookEvents}
        selectedDailyLog={selectedDailyLog}
        i18n={i18n}
      />
    </Styled.PdfContainer>
  );
};

export default PdfView;